import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CreditCard } from 'src/app/models/credit-card.model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-new-card',
  templateUrl: './new-card.component.html',
  styleUrls: ['./new-card.component.scss'],
})
export class NewCardComponent implements OnInit {

  newData: CreditCard = new CreditCard();

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService
  ) { }

  ngOnInit() { }

  async close() {
    await this.mdlctrl.dismiss();
  }

  save() {
    const CARDS: CreditCard[] = JSON.parse(localStorage.getItem('cards')) || [];

    CARDS.push(this.newData);
    localStorage.setItem('cards', JSON.stringify(CARDS));
    this.close();
  }
}
